import { makeStyles } from 'tss-react/mui';

export default makeStyles<{ orientation: 'vertical' | 'horizontal' }, 'active'>({ name: 'Slider', uniqId: 'VUUXXW' })(
    (_theme, { orientation }, classes) => {
        return {
            root: {
                display: 'flex',
                flexDirection: orientation === 'vertical' ? 'column' : orientation === 'horizontal' ? 'row' : undefined,
                alignItems: 'center',
                gap: 12,
                boxSizing: 'border-box',
                padding: '16px 12px',
                borderRadius: 20,
                background: 'rgba(45, 45, 45, 0.50)',
                backdropFilter: 'blur(calc(var(--base-x15, 8px) / 2))',
                width: orientation === 'vertical' ? 40 : undefined,
                height: orientation === 'horizontal' ? 40 : undefined
            },
            point: {
                position: 'relative',
                display: 'flex',
                overflow: 'hidden',
                width: 8,
                height: 8,
                borderRadius: 4,
                boxSizing: 'border-box',
                background: 'rgba(255, 255, 255, 0.25)',
                transition: `width, height 0.5s, background 0.2s`,
                cursor: 'pointer',
                [`&.${classes.active}`]: {
                    cursor: 'default',
                    pointerEvents: 'none',
                    height: orientation === 'vertical' ? 48 : undefined,
                    width: orientation === 'horizontal' ? 48 : undefined
                },
                [`&:hover`]: {
                    background: 'rgba(255, 255, 255, 0.5)'
                }
            },
            progress: {
                width: 'inherit',
                height: 'inherit',
                background: '#fff',
                borderRadius: 'inherit',
                display: 'none',
                [`&.${classes.active}`]: {
                    display: 'inline'
                }
            },
            active: {}
        };
    }
);
